import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { Button } from '@src/components/ui/button/button';
import { usePreventNavigationContext } from '@src/components/hooks/usePreventNavigationNative';
import { LoggedInUserPropType } from '@src/components/prop-types/user';

export const CriminalRecordCheckProceedModal = ({ user, open, onClose }) => {
    const { enableNavigation } = usePreventNavigationContext();

    const handleProceed = () => {
        enableNavigation();
        window.location.href = `${process.env.CRIMINAL_RECORD_CHECK_PAYMENT_URL}?client_reference_id=${user.ID}`;
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent>
                <DialogContentText className='tw-text-[20px] tw-text-bcaa-grey-900 tw-font-[500]'>
                    Criminal records check
                </DialogContentText>
                <div className='tw-text-[16px] tw-text-bcaa-grey-900 tw-my-[8px] tw-space-y-[16px]'>
                    <p>
                        The criminal record check helps everyone transact with peace of mind. Once your criminal record
                        check is successfully cleared, a badge will appear next to your name in chat and on any task
                        listings you post.
                    </p>
                    <p>
                        By proceeding, you consent to:
                        <div>
                            1) BCAA providing your email to our partner Certn to complete the Basic Canadian Criminal
                            Record Check.
                        </div>
                        <div>
                            2) BCAA adding a Criminal Record Check Cleared Badge if the Basic Canadian Criminal Record
                            Check report is fully cleared.
                        </div>
                    </p>
                    <p>​For any issues during the process, please contact Certn directly.</p>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} className='tw-p-[8px] tw-text-[14px]' variant='text'>
                    CANCEL
                </Button>
                <Button onClick={handleProceed} className='tw-p-[8px] tw-text-[14px]' autoFocus variant='contained'>
                    PROCEED
                </Button>
            </DialogActions>
        </Dialog>
    );
};

CriminalRecordCheckProceedModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    user: LoggedInUserPropType
};
